import StorefrontIcon from '@mui/icons-material/Storefront';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import BugReportIcon from '@mui/icons-material/BugReport';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import { Box, ButtonBase } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { config } from '../../../../newapi/apiUrlConfig';
export const notificationsConfig =  (theme,colors,t,navigate,close,isRelation) => {

  return {
    notifications:  {
        title: 'notifications',
        icon: <BugReportIcon/>,
    },
    news:  {
        title: 'news',
        icon: <NewspaperIcon/>,
    },
    settings:  {
        icon: <StorefrontIcon/>,
        position:"right",
        component: (
          <ButtonBase
              onClick={() => {
                  if(isRelation){
                    navigate("/relation/notifications?view=notificationsettings");
                  } else {
                    navigate("/warehouse/notifications?view=notificationsettings");
                  }
                  if(close) {
                    close();
                  }
                  // if(relationMenuData) {
                      // const href = "https://www.clicktoreturn.com/"+relationMenuData.portalCode;
                      // window.open(href, '_blank'); // Opens in new tab
                  // }
              }}
              sx={{
                  height:40,
                  borderRadius:5,
                  // px:2,
                  display:"flex",
                  alignItems:"center",
                  justifyContent:'center',
                  // background: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                  color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                  fontSize:14,
                  fontWeight:700,
                  fontFamily:"Roboto, sans-serif",
              }}
          >
              {/* <Box sx={{width:24,mr:"auto"}}></Box> */}
              <SettingsOutlinedIcon/>
              {/* <OpenInNewOutlinedIcon sx={{ml:"auto",color:colors.txt["softened"]}} /> */}
          </ButtonBase>
        )
    }
  }
}; 